module.exports = __webpack_public_path__ + "img/dna.b86934b2.png";